import * as React from "react"
import "@fontsource/poppins/500.css"
import "@fontsource/poppins/600.css"
import "@fontsource/poppins/700.css"
import "@fontsource/poppins/800.css"
import "@fontsource-variable/inter"
import "@fontsource/caveat/500.css"
import "@fontsource/caveat/600.css"
import "./src/styles/global.css"
import { AuthProvider } from "./src/context/auth"
import wrapPage from "./src/wrap-page-element"
import { recordVisit } from "./src/lib/visit-log"

/**
 * One auth provider around the whole app, so every page reads the same session
 * and a navigation does not re-fetch it.
 */
export const wrapRootElement = ({ element }) => <AuthProvider>{element}</AuthProvider>

/** The site footer under every page — MTC-FCS-046. See src/wrap-page-element.js. */
export const wrapPageElement = wrapPage

/**
 * Where this visitor came from — MTC-FCS-038.
 *
 * On the FIRST load `prevLocation` is null and `document.referrer` holds the
 * outside page that sent them; on later navigations the log ignores internal
 * movement unless a new affiliate id appears. Kept in their own browser — see
 * src/lib/visit-log.js for why that is the right place for it.
 */
export const onRouteUpdate = ({ location }) => {
  try {
    recordVisit({
      search: location?.search || window.location.search,
      referrer: document.referrer,
      host: window.location.host,
    })
  } catch {
    /* Tracking must never be the reason a page fails to render. */
  }
}
